import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import { SdsInputButtonStyled, SdsInputDivStyled, SdsInputStyled, SdsInputLabelStyled } from './SdsInputStyled';

class SdsInput extends PureComponent {
	state = {
		isTypePassword: this.props.type === 'password',
		type: this.props.type
	};

	handleTogglePasswordText = e => {
		e.preventDefault();
		this.setState({ type: this.state.type === 'password' ? 'text' : 'password' });
	};

	render() {
		const { input, meta, disabled, noWrapCaption, ...passthrough } = this.props;
		const { error, touched } = meta;
		const showError = touched && error;

		return (
			<div
				className={classnames('sds-form-group', {
					'sds-form-group--error': showError,
					'sds-form-group--disabled': disabled
				})}>
				<SdsInputDivStyled className="sds-input-wrapper sds-input--floating-label">
					<SdsInputStyled
						id={input.name}
						className={classnames('sds-input', { 'sds-input--filled': input.value || input.defaultValue })}
						{...input}
						{...passthrough}
						type={this.state.type}
					/>
					<SdsInputLabelStyled className="sds-label" htmlFor={input.name}>
						<FormattedMessage id={this.props.label} />
					</SdsInputLabelStyled>
					{this.state.isTypePassword && (
						<SdsInputButtonStyled
							type="button"
							className="sds-input__icon"
							tabIndex="-1"
							onClick={this.handleTogglePasswordText}>
							<i className="material-icons">remove_red_eye</i>
						</SdsInputButtonStyled>
					)}
				</SdsInputDivStyled>
				{showError && (
					<span className={classnames('sds-caption', noWrapCaption && 'sds-caption--no-wrap')}>
						<FormattedMessage id={error} />
					</span>
				)}
			</div>
		);
	}
}

SdsInput.propTypes = {
	label: PropTypes.string.isRequired
};

export default SdsInput;
